import { BankAccount } from '@diamond/shared/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { getBankAccount } from '../queries';
import { useAuthStore, useShipToStore } from '../stores';

export function getBankAccountOptions(access_token: string, warehouse: string) {
  return queryOptions<BankAccount>({
    queryKey: ['BankAccount', warehouse],
    queryFn: () => getBankAccount(access_token, warehouse),
    enabled: !!warehouse,
  });
}

export const useGetBankAccount = () => {
  const session = useAuthStore();
  const { selectedShipToId: warehouse } = useShipToStore();

  return useQuery(getBankAccountOptions(session.access_token, warehouse));
};
